module.exports = __webpack_public_path__ + "static/media/apollonian-dionysiac.1fb57949.png";